export default __webpack_public_path__ + "static/media/property_232.adddcbcf.png";